import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import withLicenseDuplicateVehicle from 'app/components/Hoc/withLicenseDuplicateVehicle';

function VehicleCity(props) {
  const { classes, oldVehicle, newVehicle } = props;

  return (
    <>
      {Object.keys(oldVehicle).length > 0 && (
        <>
          <Grid item xs={12}>
            <h3 className={classes.greenTitle}>Informações NOVAS na licença</h3>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Placa do veículo"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={newVehicle.plate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Município"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={newVehicle.city}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Tipo de veículo"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={newVehicle.type}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              name=""
              label="Capacidade"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={newVehicle.capacity}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name=""
              label="Categoria"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={newVehicle.category}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
}

export default withLicenseDuplicateVehicle(VehicleCity);
